// removed by extract-text-webpack-plugin
module.exports = {"chartLegend":"chart-area-module__chartLegend___1eNJA","chartLegendBold":"chart-area-module__chartLegendBold___quxlO","chartBottomText":"chart-area-module__chartBottomText___25ZZy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-card-row/chart-area.module.scss
// module id = 851
// module chunks = 0 1